// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__AGJ46","btnIcon":"styles_btnIcon__2OUuT","green":"styles_green__3N1of","yellow":"styles_yellow__2tky5","left":"styles_left__b-9Ll"};